export function isAdminUser(user) {
  if (!user) return false;
  return Boolean(user.isStaff || user.isAdmin || user.isTest);
}
